import { Box } from '@mui/material';
import HeaderSearch from './Search';
import HeaderNotifications from './Notifications';

function HeaderButtons() {
  return (
    <Box
      sx={{
        mr: 0.5,
        display: 'flex',
        alignItems: 'center',
        gap: 0,
        flexDirection: 'row',
        flexShrink: 0
      }}
    >
      <HeaderSearch />
      <HeaderNotifications />
    </Box>
  );
}

export default HeaderButtons;
